"use strict";
var __values = (this && this.__values) || function(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function () {
            if (o && i >= o.length) o = void 0;
            return { value: o && o[i++], done: !o };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.InlineStack = exports.StyleStack = void 0;
var lodash_1 = __importDefault(require("lodash"));
var TokenModels_1 = __importDefault(require("ContentTokens/TokenModels"));
var point_1 = __importDefault(require("qed/src/point"));
var range_1 = __importDefault(require("qed/src/range"));
var StyleStack = (function () {
    function StyleStack() {
        this.bold = 0;
        this.italic = 0;
        this.strikethrough = 0;
        this.href = null;
    }
    StyleStack.prototype.addStyle = function (style) {
        if (this[style] == undefined) {
            throw new Error("unsupported style: ".concat(style));
        }
        this[style] += 1;
    };
    StyleStack.prototype.removeStyle = function (style) {
        if (this[style] == undefined) {
            throw new Error("unsupported style: ".concat(style));
        }
        if (this[style] > 0) {
            this[style] -= 1;
        }
    };
    return StyleStack;
}());
exports.StyleStack = StyleStack;
var InlineStack = (function () {
    function InlineStack() {
        this.stack = [];
    }
    InlineStack.prototype.push = function (element, inlineAttrs) {
        if (element.style) {
            if (element.style["font-weight"] == "bold") {
                inlineAttrs.addStyle("bold");
            }
            if (element.style["font-style"] == "italic") {
                inlineAttrs.addStyle("italic");
            }
            if (element.style["text-decoration"] == "line-through" ||
                element.style["text-decoration-line"] == "line-through") {
                inlineAttrs.addStyle("strikethrough");
            }
        }
        this.stack.push(element);
    };
    InlineStack.prototype.pop = function (inlineAttrs) {
        if (!this.stack.length) {
            throw new Error("imbalanced element");
        }
        var element = this.stack.pop();
        if (element.style) {
            if (element.style["font-weight"] == "bold") {
                inlineAttrs.removeStyle("bold");
            }
            if (element.style["font-style"] == "italic") {
                inlineAttrs.removeStyle("italic");
            }
            if (element.style["text-decoration"] == "line-through" ||
                element.style["text-decoration-line"] == "line-through") {
                inlineAttrs.removeStyle("strikethrough");
            }
        }
    };
    return InlineStack;
}());
exports.InlineStack = InlineStack;
var HtmlTokenizer = (function () {
    function HtmlTokenizer() {
        this.inlineAttrs = null;
        this.inlineStack = null;
        this.blockStack = null;
        this.tokens = null;
        this.list = null;
        this.isNested = null;
    }
    HtmlTokenizer.prototype.tokenize = function (contentElem, widgets) {
        this.inlineAttrs = new StyleStack();
        this.contentElement = contentElem;
        this.inlineStack = new InlineStack();
        this.isNested = false;
        this.list = [];
        if (!contentElem) {
            throw new Error("Attempted to tokenize an invalid element");
        }
        this.blockStack = [];
        this.insertWidgetsData(contentElem, widgets);
        this.tokens = [];
        var start = point_1.default.start(contentElem);
        var end = point_1.default.end(contentElem);
        var range = new range_1.default(start, end);
        var iterator = range.iterateRight();
        while (true) {
            var element = iterator.enterElement();
            if (element) {
                var token = this.processEnterElement(element);
                if (token) {
                    this.tokens.push(token);
                }
                continue;
            }
            var textRange = iterator.skipText();
            if (textRange) {
                var token = this.processText(textRange);
                if (token) {
                    this.tokens.push(token);
                }
                continue;
            }
            element = iterator.leaveElement();
            if (element) {
                this.processLeaveElement(element);
                continue;
            }
            if (iterator.isAtEnd()) {
                break;
            }
        }
        if (this.blockStack.length != 0) {
            throw new Error("Unclosed tags!: ".concat(this.blockStack));
        }
        this.validateTokenArray();
        return this.tokens;
    };
    HtmlTokenizer.prototype.processEnterElement = function (element) {
        var tagName = element.tagName.toLowerCase();
        var token = null;
        if (isBlockTag(tagName)) {
            token = this.processBlock(element, tagName);
        }
        else if (isInlineTag(tagName)) {
            this.processInline(element, tagName);
        }
        else if (isListTag(tagName)) {
            token = this.processList(element, tagName);
        }
        else if (isBreak(tagName)) {
            token = this.processBreak();
        }
        else if (isInsertableTag(element, tagName)) {
            token = this.processInsertable(element, tagName);
        }
        return token;
    };
    HtmlTokenizer.prototype.processLeaveElement = function (element) {
        var tagName = element.tagName.toLowerCase();
        if (isBlockTag(tagName)) {
            this.closeBlock(tagName);
        }
        else if (isInlineTag(tagName)) {
            this.closeInline(tagName);
        }
        else if (isListTag(tagName)) {
            this.closeList(tagName);
        }
        else if (isInsertableTag(element, tagName)) {
            this.closeInsertable();
        }
        return;
    };
    HtmlTokenizer.prototype.processBlock = function (element, tagName) {
        var token = null;
        token = this.createBlockToken(tagName);
        if (this.blockStack.length > 0) {
            this.isNested = true;
            if (this.tokens[this.tokens.length - 1].subType == "text") {
                if (isBlockTag(this.blockStack[0])) {
                    token = this.createBlockToken(this.blockStack[0]);
                }
                else {
                    token = this.processBreak();
                }
            }
            else {
                token = null;
            }
        }
        this.inlineStack.push(element, this.inlineAttrs);
        this.blockStack.push(tagName);
        return token;
    };
    HtmlTokenizer.prototype.closeBlock = function (tagName) {
        if (this.blockStack[this.blockStack.length - 1] != tagName) {
            throw new Error("Unexpected tag");
        }
        this.blockStack.pop();
        if (this.blockStack.length == 0) {
            this.isNested = false;
        }
        this.inlineStack.pop(this.inlineAttrs);
    };
    HtmlTokenizer.prototype.createBlockToken = function (tagName) {
        var token = null;
        switch (tagName) {
            case "p":
                token = TokenModels_1.default.paragraph.createToken();
                break;
            case "h1":
                token = TokenModels_1.default.heading1.createToken();
                break;
            case "h2":
                token = TokenModels_1.default.heading2.createToken();
                break;
            case "blockquote":
                token = TokenModels_1.default.blockQuote.createToken();
                break;
            default:
                throw new Error("Unsupported block: ".concat(tagName));
        }
        return token;
    };
    HtmlTokenizer.prototype.processBreak = function () {
        if (!this.tokens.length) {
            return null;
        }
        if (this.blockStack.length > 0) {
            return TokenModels_1.default.lineBreak.createToken();
        }
        return null;
    };
    HtmlTokenizer.prototype.processInline = function (element, tagName) {
        switch (tagName) {
            case "a":
                this.inlineAttrs.href = element.href;
                break;
            case "b":
                this.inlineAttrs.addStyle("bold");
                break;
            case "i":
                this.inlineAttrs.addStyle("italic");
                break;
            case "s":
                this.inlineAttrs.addStyle("strikethrough");
                break;
            case "span":
                this.inlineStack.push(element, this.inlineAttrs);
                break;
            default:
                throw new Error("Unsupported style: ".concat(tagName));
        }
    };
    HtmlTokenizer.prototype.closeInline = function (tagName) {
        switch (tagName) {
            case "a":
                this.inlineAttrs.href = null;
                break;
            case "b":
                this.inlineAttrs.removeStyle("bold");
                break;
            case "i":
                this.inlineAttrs.removeStyle("italic");
                break;
            case "s":
                this.inlineAttrs.removeStyle("strikethrough");
                break;
            case "span":
                this.inlineStack.pop(this.inlineAttrs);
                break;
            default:
                throw new Error("Unsupported inline: ".concat(tagName));
        }
    };
    HtmlTokenizer.prototype.processInsertable = function (element, tagName) {
        var widgetModelStr = element.getAttribute("qwilr-widget-model");
        var widgetModel = {};
        if (!widgetModelStr) {
            return null;
        }
        else {
            widgetModel = JSON.parse(widgetModelStr);
        }
        if (tagName == "div") {
            if (!widgetModel.url) {
                widgetModel.url = "";
            }
            if (!widgetModel.type) {
                widgetModel.type = "image";
            }
        }
        switch (widgetModel.type) {
            case "image":
                return TokenModels_1.default.image.createToken(widgetModel.url, {
                    width: widgetModel.displayWidth,
                });
            case "table":
                var token = createTableToken(widgetModel, this.contentElement);
                return token;
            case undefined:
                return null;
            default:
                if (lodash_1.default.isEqual({}, widgetModel)) {
                    throw new Error("Widget data missing");
                }
                throw new Error("Unhandled widget type ".concat(widgetModel.type, ", ").concat(widgetModelStr));
        }
    };
    HtmlTokenizer.prototype.closeInsertable = function () {
        return;
    };
    HtmlTokenizer.prototype.processList = function (element, tagName) {
        switch (tagName) {
            case "ol":
                this.list.push({
                    type: "number",
                });
                break;
            case "ul":
                this.list.push({
                    type: "bullet",
                });
                break;
            case "li":
                this.blockStack.push(tagName);
                if (this.list.length > 0) {
                    var currentLevel = this.list.length;
                    return TokenModels_1.default.listItem.createToken(this.list[this.list.length - 1].type, currentLevel);
                }
                else {
                    return TokenModels_1.default.listItem.createToken("bullet", 1);
                }
            default:
                throw new Error("Unsupported list: ".concat(tagName));
        }
    };
    HtmlTokenizer.prototype.closeList = function (tagName) {
        switch (tagName) {
            case "ol":
                if (this.list.length === 0) {
                    throw new Error("Unexpected tag");
                }
                if (this.list[this.list.length - 1].type != "number") {
                    throw new Error("Unexpected tag. Expecting </ol> tag");
                }
                this.list.pop();
                break;
            case "ul":
                if (this.list.length === 0) {
                    throw new Error("Unexpected tag");
                }
                if (this.list[this.list.length - 1].type != "bullet") {
                    throw new Error("Unexpected tag. Expecting </ul> tag");
                }
                this.list.pop();
                break;
            case "li":
                if (this.blockStack[this.blockStack.length - 1] != tagName) {
                    throw new Error("Unexpected tag");
                }
                this.blockStack.pop();
                break;
            default:
                throw new Error("Unsupported list: ".concat(tagName));
        }
    };
    HtmlTokenizer.prototype.processText = function (textRange) {
        if (this.blockStack.length == 0) {
            return null;
        }
        var lastToken = this.tokens[this.tokens.length - 1];
        if (this.isNested) {
            if (lastToken.subType == "text") {
                this.tokens.push(this.createBlockToken(this.blockStack[0]));
            }
        }
        if (lastToken.type == "block" && lastToken.subType == "image") {
            if (this.list.length > 0) {
                var currentLevel = this.list.length;
                this.tokens.push(TokenModels_1.default.listItem.createToken(this.list[this.list.length - 1].type, currentLevel));
            }
            else {
                this.tokens.push(this.createBlockToken(this.blockStack[0]));
            }
        }
        var nodeText = customTrim(textRange.getText());
        var originalText = textRange.getText();
        var previousToken = this.tokens[this.tokens.length - 1];
        if (originalText[0] === " " && previousToken && previousToken.subType == "text") {
            nodeText = " " + nodeText;
        }
        if (nodeText.length > 0) {
            return createTextToken(nodeText, this.inlineAttrs);
        }
        return null;
    };
    HtmlTokenizer.prototype.insertWidgetsData = function (elem, widgets) {
        var e_1, _a;
        if (!widgets || lodash_1.default.isEqual({}, widgets)) {
            return;
        }
        var insertableElems = elem.getElementsByTagName("insertable");
        try {
            for (var insertableElems_1 = __values(insertableElems), insertableElems_1_1 = insertableElems_1.next(); !insertableElems_1_1.done; insertableElems_1_1 = insertableElems_1.next()) {
                var e = insertableElems_1_1.value;
                var id = e.getAttribute("widget-id");
                var model = widgets[id] || {};
                var idField = "$id";
                model[idField] = id;
                e.setAttribute("qwilr-widget-model", JSON.stringify(model));
                delete model[idField];
            }
        }
        catch (e_1_1) { e_1 = { error: e_1_1 }; }
        finally {
            try {
                if (insertableElems_1_1 && !insertableElems_1_1.done && (_a = insertableElems_1.return)) _a.call(insertableElems_1);
            }
            finally { if (e_1) throw e_1.error; }
        }
    };
    HtmlTokenizer.prototype.validateTokenArray = function () {
        this.tokens = removeEmptyBlockTokens(this.tokens);
        this.tokens = removeTrailingBreakTokens(this.tokens);
        this.tokens = addTextTokens(this.tokens);
        this.tokens = mergeTextTokens(this.tokens);
    };
    return HtmlTokenizer;
}());
exports.default = HtmlTokenizer;
var removeEmptyBlockTokens = function (tokens) {
    var previous = null;
    var current = null;
    for (var i = 0; i < tokens.length; i++) {
        current = tokens[i];
        if (previous && current.type == "block" && needsTextToken(previous)) {
            tokens.splice(i - 1, 1);
        }
        previous = tokens[i];
    }
    if (previous && needsTextToken(previous)) {
        tokens.splice(tokens.length - 1, 1);
    }
    return tokens;
};
var removeTrailingBreakTokens = function (tokens) {
    var previous = null;
    var validated = [];
    var current = null;
    for (var i = tokens.length - 1; i >= 0; i--) {
        current = tokens[i];
        if (!previous || previous.type == "block") {
            if (current.subType == "lineBreak") {
                continue;
            }
        }
        validated.unshift(current);
        previous = current;
    }
    return validated;
};
var addTextTokens = function (tokens) {
    var previous = null;
    var current = null;
    for (var i = 0; i < tokens.length; i++) {
        current = tokens[i];
        if (previous && current.type == "block" && needsTextToken(previous)) {
            var token = TokenModels_1.default.text.createToken("");
            tokens.splice(i, 0, token);
        }
        previous = tokens[i];
    }
    if (previous && needsTextToken(previous)) {
        var token = TokenModels_1.default.text.createToken("");
        tokens.push(token);
    }
    return tokens;
};
var mergeTextTokens = function (tokens) {
    var previous = null;
    var current = null;
    for (var i = 0; i < tokens.length; i++) {
        current = tokens[i];
        if (previous && current.subType == "text" && previous.subType == "text") {
            if (lodash_1.default.isEqual(previous.style, current.style) && previous.href == current.href) {
                previous.content += current.content;
                tokens.splice(i, 1);
            }
        }
        previous = tokens[i];
    }
    return tokens;
};
var isBlockTag = function (tagName) {
    var blockTags = ["p", "h1", "h2", "blockquote"];
    return lodash_1.default.includes(blockTags, tagName);
};
var isInlineTag = function (tagName) {
    var inlineTags = ["a", "b", "i", "span"];
    return lodash_1.default.includes(inlineTags, tagName);
};
var isBreak = function (tagName) {
    return tagName == "br";
};
var isListTag = function (tagName) {
    var listTags = ["ol", "ul", "li"];
    return lodash_1.default.includes(listTags, tagName);
};
var isInsertableTag = function (element, tagName) {
    var widgetModelStr = element.getAttribute("qwilr-widget-model");
    if (tagName == "div" && widgetModelStr) {
        return true;
    }
    return tagName == "insertable";
};
var createTextToken = function (textStr, inlineAttrs) {
    textStr = sanitizeText(textStr);
    var token = TokenModels_1.default.text.createToken(textStr);
    if (inlineAttrs.href) {
        token.href = inlineAttrs.href;
    }
    if (inlineAttrs.bold || inlineAttrs.italic || inlineAttrs.strikethrough) {
        token.style = {};
        if (inlineAttrs.bold) {
            token.style.bold = true;
        }
        if (inlineAttrs.italic) {
            token.style.italic = true;
        }
        if (inlineAttrs.strikethrough) {
            token.style.strikethrough = true;
        }
    }
    return token;
};
var needsTextToken = function (token) {
    var textTokenRequired = ["paragraph", "heading1", "heading2", "blockQuote", "listItem"];
    if (token.type == "block") {
        if (lodash_1.default.includes(textTokenRequired, token.subType)) {
            return true;
        }
    }
    return false;
};
var sanitizeText = function (textContent) {
    return textContent.replace(/\n|\r|\t|\v|\f/g, "");
};
var customTrim = function (textContent) {
    textContent = textContent.replace(/(\n|\r)+/gm, " ");
    textContent = textContent.replace(/^[ \f\n\r\t\v\u1680\u2000-\u200a\u2028\u2029\u202f\u205f\u3000\ufeff]+/g, "");
    textContent = textContent.replace(/[\f\n\r\t\v\u1680\u2000-\u200a\u2028\u2029\u202f\u205f\u3000\ufeff]+$/g, "");
    textContent = textContent.replace(/\u00a0/g, " ");
    return textContent;
};
var createTableToken = function (widgetData, contentElement) {
    var newElement = contentElement.ownerDocument.createElement("div");
    var cells = widgetData.table.map(function (row) {
        return row.map(function (cell) {
            newElement.innerHTML = cell.content;
            var newTokenizer = new HtmlTokenizer();
            return newTokenizer.tokenize(newElement, null);
        });
    });
    newElement.remove();
    var columnBorders = widgetData.colOffsets;
    columnBorders.push(100);
    columnBorders.unshift(0);
    return TokenModels_1.default.table.createToken(widgetData.rows, widgetData.cols, cells, columnBorders);
};
